import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2 text-sm text-neutral-900 group-hover:text-primary-600" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex flex-col h-full overflow-y-scroll bg-white rounded-l-lg shadow-xl" }
const _hoisted_4 = { class: "relative flex flex-col h-full" }
const _hoisted_5 = { class: "flex items-center px-6 pt-6 pb-2 space-x-2 shrink-0" }
const _hoisted_6 = { class: "text-sm text-neutral-900" }
const _hoisted_7 = { class: "relative group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-6 z-10 rounded bg-gray-500 p-3 text-white text-xs min-w-[220px] group-hover:block hidden" }, [
  /*#__PURE__*/_createElementVNode("p", null, "This type allows a response of one or a few words."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Tip:"),
    /*#__PURE__*/_createTextVNode(" If you wish to add another input field beside this one, simply set the width to half.")
  ])
], -1)
const _hoisted_9 = { class: "flex flex-col flex-1 px-6 pt-5 pb-6" }
const _hoisted_10 = { class: "flex flex-col flex-1 h-full space-y-5" }
const _hoisted_11 = { class: "flex space-x-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "pt-1 text-xs font-semibold text-neutral-600" }, "Is field required?", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-3 text-xs font-semibold text-neutral-600" }, "Choose field width", -1)
const _hoisted_14 = { class: "flex flex-col space-y-2" }
const _hoisted_15 = { class: "self-end mt-6 shrink-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Add Field", -1)

import { ref, onMounted, watch, computed } from "vue";

import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import FieldLabelText from "../Components/Inputs/FieldLabelText.vue";
import FieldWidthRadio from "../Components/Inputs/FieldWidthRadio.vue";
import RequiredSwitch from "../Components/Inputs/RequiredSwitch.vue";

import {
	TransitionChild,
	TransitionRoot,
} from "@headlessui/vue";
import { InformationCircleIcon, ArrowLeftIcon } from "@heroicons/vue/24/outline";

import TextInput from "@/components/inputs/TextInput.vue";
import ToggleSwitch from "@/components/inputs/ToggleSwitch.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import { FormFieldType } from "@/views/enums/FormFieldType";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputModal',
  props: {
	item: {
		type: Object,
		required: true,
	},
	fieldType: {
		type: Number,
		required: true,
	},
	title: {
		type: String,
		default: '',
	},
},
  setup(__props) {

const props = __props;

const show = ref<boolean>(false);

const form = ref<{
	label: string|null,
	input_type: number,
	is_half_width: boolean,
	is_required: boolean,
	options?: any,
}>({
	label: null,
	input_type: props.fieldType,
	is_half_width: false,
	is_required: false,
	options: null,
})

const field_width_options = [
    { id: false, label: 'Whole', value: false, radioSelected: null},
    { id: true, label: 'Half', value: true, radioSelected: null},
]

const getFieldIcon = (field: number): string => {
    switch (field) {
        case FormFieldType.INPUT:
            return '/assets/icon/intervention/ic-text.svg';
        case FormFieldType.TEXT:
            return'/assets/icon/intervention/ic-textarea.svg';
        case FormFieldType.DROPDOWN:
            return'/assets/icon/intervention/ic-dropdown.svg';
        case FormFieldType.MULTI_SELECT:
            return'/assets/icon/intervention/ic-multiselect.svg';
        case FormFieldType.RADIO:
            return'/assets/icon/intervention/ic-radio-button.svg';
        case FormFieldType.TOGGLE:
            return'/assets/icon/intervention/ic-toggle.svg';
        case FormFieldType.CHECKBOX_SINGLE:
        case FormFieldType.CHECKBOX_OPTION:
            return'/assets/icon/intervention/ic-checkbox.svg';
        case FormFieldType.LINK:
            return'/assets/icon/intervention/ic-link.svg';
        case FormFieldType.TIME:
        case FormFieldType.DATE:
        case FormFieldType.DATE_TIME:
            return'/assets/icon/intervention/ic-datepicker.svg';
        default:
            return '';
    }
}

const openModal = ():void => {
	show.value = true;
}

const add = ():void => {
	console.log(form.value);
	// const result = v$.value.$validate().then((data) => {
	// 	console.log(data);
	// })
	// console.log(result);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "col-span-1 rounded bg-gray-50 hover:bg-primary-300 flex flex-col items-center justify-center text-center group p-6 h-[100px] cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal()))
    }, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.item.label), 1),
      _createElementVNode("img", {
        src: getFieldIcon(__props.item.value),
        class: "object-contain h-6 opacity-50 grayscale group-hover:grayscale-0 group-hover:opacity-100",
        alt: "icon"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: show.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "absolute right-0 inset-y-0 w-full overflow-hidden h-[calc(100vh-148px)]",
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transform transition ease-in-out duration-300",
              "enter-from": "translate-x-full",
              "enter-to": "translate-x-0",
              leave: "transform transition ease-in-out duration-300",
              "leave-from": "translate-x-0",
              "leave-to": "translate-x-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_unref(ArrowLeftIcon), {
                        class: "w-6 h-6 transition cursor-pointer text-neutral-500 hover:text-primary-600",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                      }),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(__props.title), 1),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(InformationCircleIcon), { class: "w-5 h-5 cursor-pointer text-primary-600" }),
                        _hoisted_8
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                          _createVNode(TextInput, {
                            type: "text",
                            label: "Field Label",
                            placeholder: "Field Label",
                            id: "field_label",
                            name: "field_label",
                            modelValue: form.value.label,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.label) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(ToggleSwitch, {
                            value: form.value.is_required,
                            noPadding: "",
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (form.value.is_required = !form.value.is_required))
                          }, null, 8, ["value"]),
                          _hoisted_12
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_13,
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(RadioGroup, {
                              options: field_width_options,
                              name: "field_width"
                            })
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(ButtonComponent, {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (add()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ], 64))
}
}

})